import axios from "axios";
import routes from "./routes";
import {
  STORAGE_KEY_ACCESS_TOKEN,
  STORAGE_KEY_LOGGED_USER,
} from "@/constants/constants";

const axiosClient = axios.create({
  baseURL: `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
  headers: {
    'X-Platform': 'web',
  },
});

// Response interceptor - on 401 for an authenticated session, clear state and
// redirect to login. A 401 with no stored token means the user simply was not
// logged in yet (e.g. a request racing the login handshake); in that case we
// reject quietly so a stray 401 cannot tear down an in-progress login.
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadToken = Boolean(localStorage.getItem(STORAGE_KEY_ACCESS_TOKEN));

      if (hadToken) {
        localStorage.removeItem(STORAGE_KEY_ACCESS_TOKEN);
        localStorage.removeItem(STORAGE_KEY_LOGGED_USER);
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export function addHeader(name, value) {
  axiosClient.defaults.headers.common[name] = value;
}

export function removeHeader(name) {
  delete axiosClient.defaults.headers.common[name];
}

let loaded = false;

export async function configure() {
  if (loaded) {
    return;
  }

  loaded = true;
}

export function buildUrl(routeName, params = {}) {
  const url = routes[routeName];
  if (!url) {
    throw new Error(`Invalid route name: "${routeName}"`);
  }

  return Object.entries(params).reduce((updatedUrl, [key, value]) => {
    const pattern = new RegExp("{" + key + "}", "g");
    return updatedUrl.replace(pattern, value);
  }, url);
}

/**
 *
 * @param {(p0: import('axios').Axios) => void} callback
 * @returns
 */
export function withAxiosClient(callback) {
  return (...args) => callback(axiosClient, ...args);
}
